<div class='padding-10'>
  <h2>Settings / Custom filters</h2>
  <div>
    <p>Currently in development</p>
  </div>
</div>
